<div class="col-sm-12" style="height: 100%; padding-top: 5px;">
  <div class="fiche col-sm-12" style="padding: 2px 20px 5px 20px;">
    <div class="text-right col-sm-12 pull-right" style="padding-right: 0;">
      <div class="col-sm-6 fiche-client">
        <div> Grille de tarification </div>
      </div>
      
      <button class="uppercase" id="savecont"  *ngIf = '!isHisto'  (click)="saveAgence()"> Enregistrer </button>
      <button class="uppercase"   *ngIf = 'isHisto'  (click)="hidemodal()"> Fermer </button>
    </div>
  </div>
  <div class="contente ligneBon col-sm-12">
    
    <div class="col-sm-12" style="margin-top: 15px;">

      <div class="col-sm-5" style="padding: 5px;" *ngIf = '!isHisto'>
        <button class="btn-add" (click)="addLigne()">
          <i class="fa fa-plus"></i>
        </button>
        <span (click)="addLigne()"> Ajouter un tarif </span>
      </div>

      <div class="col-sm-7 text-right" style="padding: 5px;" *ngIf="showQteSupp">
          <mat-checkbox class="example-margin" color="primary" [(ngModel)]="qteSupp" (ngModelChange)="changeQteSupp()">
              Qté supp sur l'avant dernier prix </mat-checkbox>
      </div>
    </div>

    <div class="col-sm-12" style="padding: 5px; " [ngClass]="{'showQteSupp': showQteSupp, 'notshowQteSupp': !showQteSupp}">
      <ngx-datatable class="material" [rows]="listTarifQte" style="height: 100%;" [columnMode]="'force'" [headerHeight]="30"
        [footerHeight]="0" [rowHeight]="'auto'" [selectionType]="'single'" [messages]="{emptyMessage: loadingIndicator ? 'Chargement ...' :'Pas de tarification à afficher'}"
        [loadingIndicator]="loadingIndicator">

        <ngx-datatable-column name="quantite" prop="quantite">
          <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
            let-sort="sortFn">
            <div class="tableheader">
              <span class="uppercase"> Quantite </span>
            </div>
          </ng-template>
          <ng-template let-value="value" let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
            <div *ngIf="row.edit || !row.id" class="focusQ" > <input type="number"  step="0.001" id="qte{{rowIndex}}" class="form-control" [(ngModel)]="row.quantite" (keydown.enter)="common.focusNext('.ligneBon')"> </div>
            <div *ngIf="!row.edit && row.id"> {{ common.toFixed(value || 0) }} </div>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="tarif" prop="tarif">
          <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
            let-sort="sortFn">
            <div class="tableheader">
              <span class="uppercase"> Tarif </span>
            </div>
          </ng-template>
          <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
            <div  *ngIf="row.edit || !row.id"> <input type="number" step="0.001" class="form-control" [(ngModel)]="row.tarif"> </div>
            <div *ngIf="!row.edit && row.id"> {{ common.toFixed(value || 0) }} </div>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column [width]="50" *ngIf = '!isHisto'>
          <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row">
            <button *ngIf="row.id" class="btn-detail" (click)="row.edit = !row.edit; showInput(rowIndex)">
              <i class="fa fa-pencil"></i>
            </button>
            <button class="btn-detail" (click)="deleteLigne(row)">
              <i class="fa fa-trash"></i>
            </button>
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>
    </div>
    
  </div>
</div>